import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { apiClient } from "api"
import { CattoJob } from "./types"
import { CAT2_API_BASE_URL } from "./constants"

export const getJobs = ({ queryKey }) => {
  const [_, params] = queryKey
  return apiClient.get(`${CAT2_API_BASE_URL}/jobs`, params)
}

export const useCatJobs = (catProjectId?: string) =>
  useQuery<{ data: CattoJob[], translate_urls: Record<string, string>, counts: Record<string, Record<string, number>> }>({
    queryFn: getJobs,
    queryKey: ['catJobs', {
      project_id: catProjectId,
    }],
    enabled: !!catProjectId,
    refetchInterval: (data) => {
      const isInProgress = data?.data.some(
        (job) => job.status === 'processing' || job.status === 'pretranslating'
      )
      return isInProgress ? 3000 : false
    },
  })

export const useDeleteCatJob = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => apiClient.delete(`${CAT2_API_BASE_URL}/jobs/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['catJobs'] })
      queryClient.invalidateQueries({ queryKey: ['catAnalyses'] })
    },
  })
}
